import { FC } from 'react';
import { Box, Divider } from '@hopskipdrive/react-components';
import { PageHeading } from '@rideiq/shared/components/PageHeading';

import AbsentRiderNotifications from './AbsentRiderNotifications';
import LegacyNotifications from './LegacyNotifications';
import SMSAlerts from './SMSAlerts';

export interface NotificationPreferencesProps {
  accountInfo?: AccountInfo;
  editMode: boolean;
}

const NotificationPreferences: FC<NotificationPreferencesProps> = ({ accountInfo, editMode }) => {
  return (
    <Box>
      <PageHeading variant="h2" fontWeight={700} my={4}>
        Notification Preferences
      </PageHeading>

      {accountInfo?.enableAbsentRiderDailyEmail === 'Yes' ? (
        <>
          <AbsentRiderNotifications
            sendEmailDailyReport={accountInfo?.sendEmailDailyReport}
            dailyReportEmailList={accountInfo?.dailyReportEmailList}
            editMode={editMode}
          />
          <Divider style={{ margin: '48px 0' }} />
          <SMSAlerts
            messagingUpdatesRidersCaregivers={accountInfo?.messagingUpdatesRidersCaregivers}
            editMode={editMode}
          />
          <Divider style={{ margin: '48px 0' }} />
        </>
      ) : (
        <LegacyNotifications
          sendNoShowNotifications={accountInfo?.sendNoShowNotifications}
          messagingUpdatesRidersCaregivers={accountInfo?.messagingUpdatesRidersCaregivers}
          editMode={editMode}
        />
      )}
    </Box>
  );
};

export default NotificationPreferences;
